import React, { memo, useCallback, useEffect, useState } from 'react';

import classnames from 'classnames';

import { createDesign } from '@/hooks';

import ImageArrow from '@images/arrow.webp';

import { goBack } from '@/utils/bridge';

import SafeArea from '../safe-area';
import './index.scss';

type HeaderProps = {
  className?: string;
  title?: string | string[]; // 标题
  leftContent?: React.ReactNode; // 左侧内容
  rightContent?: React.ReactNode; // 右侧内容
  selected?: number;
  onBack?: () => void;
  onChange?: (index: number) => void;
};

const { prefixCls } = createDesign('cmp-header');

function Header(props: HeaderProps) {
  const [selected, setSelected] = useState(props.selected || 0);

  const handleNavigateBack = useCallback(() => {
    if (props.onBack) {
      props.onBack();
      return;
    }
    goBack();
  }, []);

  const handleSelect = useCallback((selected: number) => {
    setSelected(selected);
    props.onChange && props.onChange(selected);
  }, []);

  useEffect(() => {
    setSelected(props.selected || 0);
  }, [props.selected]);

  return (
    <>
      <div className={classnames(prefixCls, props.className)}>
        <SafeArea position="top" />
        <div className={`${prefixCls}-container`}>
          <SafeArea position="top" />
          <div className={`${prefixCls}-container__content`}>
            {props.leftContent ? (
              props.leftContent
            ) : (
              <div className={`${prefixCls}-container__arrow`} onClick={handleNavigateBack}>
                <img src={ImageArrow} />
              </div>
            )}
            {props.title && (
              <>
                {Array.isArray(props.title) ? (
                  <div className={`${prefixCls}-container__title-items`}>
                    {props.title.map((item, i) => (
                      <div
                        className={classnames(`${prefixCls}-container__title-items-item`, {
                          selected: i === selected,
                        })}
                        key={i}
                        onClick={() => handleSelect(i)}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={`${prefixCls}-container__title`}>{props.title}</div>
                )}
              </>
            )}
            {props.rightContent && (
              <div className={`${prefixCls}-container__right`}>{props.rightContent}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(Header);
